module.exports = __webpack_public_path__ + "img/avatar.b03f2462.jpg";